import React from "react";
import { PlantillaVistaActividadesByProceso } from "./PlantillaVistaActividadesByProceso";
import { useActividadesPorGrupo } from "../../../hooks/IpercLineaBase/useActividadesPorGrupo";
import { CabeceraTable } from "../../../components/Table/CabeceraTable";
import { Label, SearchBox } from "@fluentui/react";
import { useListarProcesosLaPoderosa } from "../../../hooks/IpercLineaBase/ProcesosLineaBase/useListarProcesosLaPoderosa";
import { NavProcesos } from "../../../components/SSidebar/NavProcesos";

export const MapaProcesos = () => {
  const { data } = useActividadesPorGrupo();
  const { dataProceso } = useListarProcesosLaPoderosa();

  return (
    <>
      <div className="ms-Grid" dir="ltr">
        <div
          className="ms-Grid-row"
          style={{
            margin: "15px",
          }}
        >
          <div className="ms-Grid-col ms-md3 ms-lg12">
            <CabeceraTable
              SubTitulo="Gestión de Procesos"
              Titulo="Mapa de Procesos"
            />
          </div>
        </div>
        <div
          className="ms-Grid-row"
          style={{
            height: "850px",
            overflowY: "scroll",
          }}
        >
          <div className="ms-Grid-col ms-md3 ms-lg3">
            <div style={{ margin: "10px" }}>
              <Label
                style={{
                  color: "Black",
                  fontSize: "16px",
                  padding: "5px",
                  fontWeight: "initial",
                }}
              >
                Lista de Procesos
              </Label>
              <br />
              <SearchBox placeholder="Search" underlined={true} />
              <NavProcesos onClick={() => {}} data={dataProceso} />
            </div>
          </div>
          <div
            className="ms-Grid-col ms-md3 ms-lg9"
            style={{ borderLeft: "0.5px solid #edebe9" }}
          >
            <div style={{ margin: "30px" }}>
              <PlantillaVistaActividadesByProceso
                procesoNombre="TECNOLOGÍA DE INFORMACIÓN"
                data={data}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
